exports = module.exports = require("../../../../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-components-notifications-onboarding-modularization--modularization-module-modal [class^=ant-modal-content]{border-top-right-radius:0}", ""]);

// exports
exports.locals = {
	"modal": "src-components-notifications-onboarding-modularization--modularization-module-modal"
};